import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js"

// Connects to data-controller="tooltip"
export default class extends Controller {
  static values = {
    title: String,
    text: String,
    delay: {
      type: Number,
      default: 0
    },
    distance: {
      type: Number,
      default: 10
    },
    placement: {
      type: String,
      default: "top"
    },
    maxWidth: {
      type: Number,
      default: 350
    },
    trigger: {
      type: String,
      default: "mouseenter focus"
    }
  }

  connect() {
    if (!this.titleValue && !this.textValue)
      return

    tippy(this.element, {
      content: `
        <div class="tooltip-title">${this.titleValue}</div>
        <div class="tooltip-text">${this.textValue}</div>
      `,
      allowHTML: true,
      arrow: '<svg width="24" height="15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.4 1.133a2 2 0 0 1 3.2 0L24 15H0L10.4 1.133Z" fill="#fff"/></svg>',
      interactive: true,
      delay: [this.delayValue, 0],
      appendTo: () => document.body,
      offset: [0, this.distanceValue],
      placement: this.placementValue,
      maxWidth: this.maxWidthValue,
      trigger: this.triggerValue
    })
  }
}
